import { useCallback, useEffect, useMemo, useState } from 'react';

import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';
import { getImpersonationExpiresAt } from '../../../utils/helpers/storage';

import { clearSession, formatPendoUser, indentifyPendoUser, initializePendo, setupPendoForUser } from './Pendo.service';

export const usePendo = () => {
  const { user } = useAuthQuery();
  const [initialized, setInitialized] = useState<boolean>(false);

  const pendoUser = useMemo(() => (user ? formatPendoUser(user) : null), [user]);

  const setUser = useCallback(async () => {
    try {
      if (!pendoUser) {
        clearSession();

        return;
      }
      if (!initialized) {
        await initializePendo(window.env.RIDEIQ_PENDO_API_KEY);
        setupPendoForUser(pendoUser);
        setInitialized(true);
      } else {
        indentifyPendoUser(pendoUser);
      }
    } catch (error) {}
  }, [pendoUser, initialized]);

  useEffect(() => {
    if (window.env.RIDEIQ_PENDO_API_KEY && !getImpersonationExpiresAt()) {
      setUser();
    }
  }, [setUser]);
};
